import { Alert, AlertType, Button, Typography } from '@gurupay/gp-ui-library';
import { useEffect, useState } from 'react';

export interface ConfirmationBannerProps {
	id: string;
	title: string;
	description: string;
	type?: AlertType;
	className?: string;
	onConfirm: () => void;
	buttonText: string;
}

const VoPConfirmationBanner = ({
	id,
	type,
	className,
	title,
	description,
	onConfirm,
	buttonText,
}: ConfirmationBannerProps) => {
	const [isOpen, setIsOpen] = useState(true);

	const handleClose = () => {
		sessionStorage.setItem(`confirmation_closed_${id}`, 'true');
		setIsOpen(false);
		onConfirm();
	};

	useEffect(() => {
		const isClosed = sessionStorage.getItem(`confirmation_closed_${id}`);
		if (isClosed === 'true') {
			setIsOpen(false);
		}
	}, [id]);

	return (
		isOpen && (
			<div className="opacity-100 translate-y-0 h-auto py-space-16">
				<Alert className={className} type={type || AlertType.WARNING}>
					<Typography level="h3">{title}</Typography>
					<Typography>{description}</Typography>
				</Alert>

				<Button
					className="md:w-max mt-space-16 w-full"
					onClick={handleClose}
					variant="primary-black"
				>
					{buttonText}
				</Button>
			</div>
		)
	);
};

export default VoPConfirmationBanner;
